import institutionAPI from 'services/institutionAPI'

type Params = {
  [key: string]: string
}

export default async function getEntityOnCustomForm(params: Params) {
  const { entityKey, id } = params

  const response = await institutionAPI({
    method: 'GET',
    url: `/citizen-portal/service/${entityKey}/${id}`,
  })

  return response
}
